export function classNames(baseClassName: string, className: string | null | undefined) {
  if (className) {
    return baseClassName + ' ' + className;
  } else {
    return baseClassName;
  }
}